// Controls logic for when clicking on data-mode handlers (Youtube, etc.)
window.templates = {
	overlay: [
		'<div class="overlay">',
			'<div class="overlay__mask"></div>',
			'<div class="overlay__content-wrapper">',
				'<div class="overlay__content" style="max-height: <%= height %>; max-width: <%= width %>;">',
					'<div class="overlay__close"><img alt="Close" src="/content/images/close-video.svg" /></div>',
					'<%= content %>',
				'</div>',
			'</div>',
		'</div>'
	],
	youtube: [
		'<iframe type="text/html" height="100%" width="100%" src="<%= src %>" frameborder="0" allowtransparency="true"></iframe>'
	]
};

$(document).on('ready', function () {
	$('body').on('click', 'a[data-link-mode="overlay"]', function (e) {
		e.preventDefault();

		var $this = $(this);
		var data = $this.data();
		var src = $this.attr('href');

		var $content;

		if (data.linkType == "youtube") {
			$content = _.template(window.templates.youtube.join(''))({
				src: src,
				height: data.contentHeight,
				width: data.contentWidth
			});
		}
		else {
			return console.warn(data.linkType, 'is not supported')
		}

		var $overlay = $(_.template(window.templates.overlay.join(''))({
			content: $content,
			height: data.contentHeight,
			width: data.contentWidth
		}));

		$overlay.on('click', '.overlay__mask, .overlay__close', function () {
			var $this = $(this);

			$this.closest('.overlay').remove();
		})

		$('body').append($overlay);
	});

	$('body').on('click', '[data-link-mode="ajax"]', function(e){
	   var element = e.target;
	   //ajax submit

	   if(element.tagName == 'A'){
	       //ajax href
	       var url = $(element).attr('href');
	       var data = '';
	       var action = null;
	       var method = 'GET';
	   } else {
	       var url = $(element).parents('form').attr('action') || window.location.href;
	       var data = $(element).parents('form').serialize();
	       var method = $(element).parents('form').attr('method') || 'GET';
	       var action = $(element).attr('value');
	   }

	   $(element).attr('disabled',true).toggleClass('active');

	   $.ajax({
	      method : method,
	      url: url,
	      data: data+'&action='+action,
	      success: function(r){
		  $(element).trigger( action );
		  $(element).attr('disabled',false).toggleClass('active');
	      },
	      error: function(e,response){
		console.log(e,response);
		$(element).attr('disabled',false).toggleClass('active');
	      }
	   });


	   e.preventDefault();

	});

	/*
	*    If you want a UI change on success
	*    register an event handler here based on the action attribute of the element
	*/

	$('button[data-link-mode="ajax"][value=confirm-order]').on('confirm-order',function(e){
	    
	    $('button[value=confirm-order]').parents('ul').find('li a').remove();
	    $(this).replaceWith('<span class="order-status__confirmed">ORDER CONFIRMED</span>');
	    
	});

	$('button[data-link-mode="ajax"]').on('save-telephone',function(e){
	    //$(this).replaceWith('<span class="order-status__confirmed">ORDER CONFIRMED</span>');
	    
	    var newNumber = $('input[name="UserDetails.Telephone"]').val();

	    $('[data-toggle-edit-field=telephone]').toggleClass('hidden');

	    $('[data-toggle-edit-display=telephone] .user-details-field__value').text(newNumber);
	    $('[data-toggle-edit-display=telephone]').toggleClass('hidden');
	    
	    $('[data-toggle-edit-display=telephone]').toggleClass('hidden');
	    
	    //Crappy carousel event handler hack
	    //Basically it's hard to identify the phone number field without retagging stuff and breaking other Degree 53 scripts
	    try {
		var fieldTag = $('button[value=save-telephone]').parents('[data-toggle-edit-field]').attr('data-toggle-edit-field');
		
		$('[data-toggle-edit-display='+fieldTag+'] .user-details-field__value').text(newNumber);
		$('a[data-toggle-edit-for='+fieldTag+']:visible').click();
	    }catch (ex){}
	    
	});
});